export const capitalize = (word: string) => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

export const titleCase = (word: string) =>
  word.split(' ').map(capitalize).join(' ');
